import { enUS, es, ptBR } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import i18n from './index';

// Locale helpers for DISPLAYING dates. Never use these for values sent to a server or saved.
const lang = () => (i18n.language || 'en').slice(0, 2);

/** BCP-47 tag for Intl / toLocale*String. Spanish uses es-US so US-style numbers stay familiar. */
export const intlLocale = (): string => ({ es: 'es-US', pt: 'pt-BR' } as Record<string, string>)[lang()] ?? 'en-US';

/** date-fns locale object for format(), formatDistance(), … */
export const dfLocale = (): Locale => ({ es, pt: ptBR } as Record<string, Locale>)[lang()] ?? enUS;

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Weekday names starting on Sunday ('long' | 'short' | 'narrow'). */
export const weekdayNames = (style: 'long' | 'short' | 'narrow' = 'short'): string[] => {
  const f = new Intl.DateTimeFormat(intlLocale(), { weekday: style });
  // 2023-01-01 was a Sunday
  return Array.from({ length: 7 }, (_, i) => cap(f.format(new Date(2023, 0, 1 + i)).replace(/\.$/, '')));
};

/** Month names, January first ('long' | 'short'). */
export const monthNames = (style: 'long' | 'short' = 'long'): string[] => {
  const f = new Intl.DateTimeFormat(intlLocale(), { month: style });
  return Array.from({ length: 12 }, (_, i) => cap(f.format(new Date(2023, i, 1)).replace(/\.$/, '')));
};

// Aliases for files that already have local variables called weekdayNames / monthNames
export const getWeekdayNames = weekdayNames;
export const getMonthNames = monthNames;
